import React, { Component } from "react";
import Section from "./layouts/Section";

class Team extends Component {
    render() {
        return (
            <Section title={'Meet The Team!'}>
                <section className="section cm-team pt-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="team-item mt-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <img className="team-img img-fluid" src={process.env.PUBLIC_URL + '/assets/images/team/ahmad.jpeg'} alt="" />
                                        </div>
                                        <div className="col-sm-6 mt-4 mt-sm-0">
                                            <h5 className="text-dark font-w-600">Ahmad</h5>
                                            <p className="small text-primary text-uppercase font-w-600 mt-1">Administrator</p>
                                            <p className="mt-15">IT Administrator, installs, evaluates, &
                                                troubleshoots.</p>
                                            <div className="barWrapper">
                                                <span className="progress-text">IT Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="99">
                                                        <span className="skill-percent">99</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Computer Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="96">
                                                        <span className="skill-percent">96</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Smartphone Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="94">
                                                        <span className="skill-percent">94</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                        </div>
                                    </div>
                                </div>
                                {/* team item */}
                            </div>
                            <div className="col-lg-6">
                                <div className="team-item mt-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <img className="team-img img-fluid" src={process.env.PUBLIC_URL + '/assets/images/team/dan.jpeg'} alt="" />
                                        </div>
                                        <div className="col-sm-6 mt-4 mt-sm-0">
                                            <h5 className="text-dark font-w-600">Dan</h5>
                                            <p className="small text-primary text-uppercase font-w-600 mt-1">Manager</p>
                                            <p className="mt-15">Device Repair Technician, Phones, Tablets, &
                                                Computers.</p>
                                            <div className="barWrapper">
                                                <span className="progress-text">Tablet Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="96">
                                                        <span className="skill-percent">96</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Computer Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="90">
                                                        <span className="skill-percent">90</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Smartphone Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="99">
                                                        <span className="skill-percent">99</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                        </div>
                                    </div>
                                </div>
                                {/* team item */}
                            </div>
                            <div className="col-lg-6">
                                <div className="team-item mt-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <img className="team-img img-fluid" src={process.env.PUBLIC_URL + '/assets/images/team/bart.jpeg'} alt="" />
                                        </div>
                                        <div className="col-sm-6 mt-4 mt-sm-0">
                                            <h5 className="text-dark font-w-600">Brett</h5>
                                            <p className="small text-primary text-uppercase font-w-600 mt-1">Repair
                                                Technician</p>
                                            <p className="mt-15">Device Repair Technician, Phones, Tablets, &
                                                Computers.</p>
                                            <div className="barWrapper">
                                                <span className="progress-text">Tablet Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="94">
                                                        <span className="skill-percent">94</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Computer Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="89">
                                                        <span className="skill-percent">89</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Smartphone Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="91">
                                                        <span className="skill-percent">91</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                        </div>
                                    </div>
                                </div>
                                {/* team item */}
                            </div>
                            <div className="col-lg-6">
                                <div className="team-item mt-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <img className="team-img img-fluid" src={process.env.PUBLIC_URL + '/assets/images/team/conlan.jpeg'} alt="" />
                                        </div>
                                        <div className="col-sm-6 mt-4 mt-sm-0">
                                            <h5 className="text-dark font-w-600">Conlan</h5>
                                            <p className="small text-primary text-uppercase font-w-600 mt-1">Developer</p>
                                            <p className="mt-15">IT Administrator/PC Repair Technician, installs, developement, &
                                                administration.</p>
                                            <div className="barWrapper">
                                                <span className="progress-text">IT Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="96">
                                                        <span className="skill-percent">96</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Computer Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="99">
                                                        <span className="skill-percent">99</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Smartphone Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="89">
                                                        <span className="skill-percent">89</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                        </div>
                                    </div>
                                </div>
                                {/* team item */}
                            </div>
                            <div className="col-lg-6">
                                <div className="team-item mt-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-6">
                                            <img className="team-img img-fluid" src={process.env.PUBLIC_URL + '/assets/images/team/me.jpeg'} alt="" />
                                        </div>
                                        <div className="col-sm-6 mt-4 mt-sm-0">
                                            <h5 className="text-dark font-w-600">Brandon</h5>
                                            <p className="small text-primary text-uppercase font-w-600 mt-1">Developer</p>
                                            <p className="mt-15">Website Designer and Developer</p>
                                            <div className="barWrapper">
                                                <span className="progress-text">Website Design</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="96">
                                                        <span className="skill-percent">96</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Computer Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="94">
                                                        <span className="skill-percent">94</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                            <div className="barWrapper">
                                                <span className="progress-text">Smartphone Repair</span>
                                                <div className="progress">
                                                    <div className="progress-bar" data-value="85">
                                                        <span className="skill-percent">85</span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* skill bar */}
                                        </div>
                                    </div>
                                </div>
                                {/* team item */}
                            </div>
                        </div>
                    </div>
                </section>
            </Section>
        );
    }
}

export default Team;